/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

//API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_CHIP_CSHCN_RATE_AUDIT,
  payload: data,
});

//Loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING_ADJUSTMENT_CHIP_CSHCN_RATES,
  isLoading: value,
});

//Manufacturer Grid
export const getManufacturerList = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(
      `${serviceEndPoint.REBATE_PERCENT_OF_SPEND_MANUFACTURER_GRID}`,
      values
    )
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_MANUFACTURER_LIST_CHIP_CSHCN_RATES,
        manufacturerList: response.data,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch([]);
      return response;
    });
};

// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
    // dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

export const setCurrentZeroUra = (data) => ({
  type: ActionTypes.GET_CURRENT_ZERO_URA,
  currentZeroResult: data,
});

//To get the defaut selection on the req screen when reopening the req screen
export const refreshCurrentZeroURA = () => ({
  type: ActionTypes.REFRESH_CURRENT_ZERO_URA,
  payload: {},
});
export const refreshCurrentZeroURADisplay = () => ({
  type: ActionTypes.REFRESH_CURRENT_ZERO_URA_DISPLAY,
  payload: {},
});

//API call for the display screen grid for checked
export const getCurrentZeroResult = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.CURRENT_ZERO_URA}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (response.data?.currentZeroURAReportVO.length === 0) {
        dispatch(showNoDataMessage());
      } else {
        return dispatch(
          setCurrentZeroUra(response.data?.currentZeroURAReportVO)
        );
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setCurrentZeroUra([]));
      // return response;
    });
};
